import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { NumberInput, SemanticUI } from '@iterable/deprecated_react_components';

export const StyledCoreNumberInput = styled(NumberInput)`
  &&& {
    .ui.input > input {
      padding-left: ${pxToRem(40)} !important;
    }
  }
`;

export const Label = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  height: 100%;
  width: ${pxToRem(40)};
  left: 0;
  top: 0;
  line-height: 1;
  padding: ${pxToRem(10)};
  font-weight: 600;
  font-size: ${pxToRem(12)};
  text-align: center;
`;

export const CityDropdownContainer = styled.div`
  display: block;
  margin-bottom: ${pxToRem(5)};
`;

export const StyledSemanticPopup = styled(SemanticUI.Popup)`
  &&&& {
    padding: ${pxToRem(5)} ${pxToRem(10)} !important;
  }
`;

export const CityLabel = styled.div`
  text-align: center;
  color: #717171;
`;

export const ReadOnlyContainer = styled.div`
  color: #717171;
  [data-role='queryBuilder']:not([data-view-mode='true']) & {
    display: none !important;
  }
`;

export const Trigger = styled.div<{ $isInline: boolean }>`
  display: inline-block;
  text-align: center;
  .cssLocationInput {
    display: flex;
    > .ui.input {
      flex: 1 1 auto;
      &:first-child {
        margin-right: -${pxToRem(1)};
      }
    }
  }
  [data-role='queryBuilder'][data-view-mode='true'] & {
    display: none !important;
  }
  ${({ $isInline }) =>
    $isInline
      ? `
    .cssLocationInput {
        width: 100%;
        > .ui.input {
        input,
        [data-role='increment'],
        [data-role='decrement'] {
            border-radius: 0 !important;
        }
        }
    }
    `
      : `
    .cssLocationInput {
        height: 100%;
        margin: auto;
        width: max-content;
        > .ui.input > input {
            min-width: ${pxToRem(160)} !important;
            max-width: ${pxToRem(260)} !important;
        }
    }
  `}
`;
